import { SET_DOCUMENT_TEMPLATES } from "../actions/documentTemplateActions";


const defaultState = {
    documentTemplates: null
}

export const documentTemplatesReducer = (state = defaultState, action: any) => {
    const { type, data } = action;
    if (type === SET_DOCUMENT_TEMPLATES) return { ...state, documentTemplates: data };
    return state;
}